export const GEOCODING_JITTER_RANGE = 1500;
